<template>
  <div id="site-administration">
    <div v-if="getSites && getSites.length !== 0 && getSite">
      <select-site/>
      <site-instant-charge-confirmation
        v-if="confirmation"
        :onConfirmed="activateInstantChargeAndHideConfirmation"
        :onCancelled="hideConfirmation"/>
      <site-instant-charge-container
        v-if="canInstantCharge"
        :instant-charge="getSite.instantCharge"
        :on-switched-on="showConfirmation"
        :on-switched-off="deactivateInstantCharge"/>
    </div>
    <div v-if="canChangeTopology">
      <site-topology-change-container v-for="deliveryPoint in getSite.deliveryPoints"
                                      id="change-topology"
                                      :key="deliveryPoint.id"
                                      :delivery-point="deliveryPoint"
                                      :can-change-topology="canChangeTopology"
                                      @topologyChanged="updateTopology">
      </site-topology-change-container>
      <site-topology-change-confirmation v-if="warning"
                                         id="change-topology-confirmation"
                                         :onConfirmed="changeTopology"
                                         :onCancelled="hideWarning">
      </site-topology-change-confirmation>
    </div>
    <no-site-administrable v-if="getSites && getSites.length === 0"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment-timezone'
import localStorage from '@/localStorage'
import SelectSite from './select-site'
import SiteInstantChargeConfirmation from './site-instant-charge-confirmation'
import SiteInstantChargeContainer from './site-instant-charge-container'
import NoSiteAdministrable from './no-site-administrable'
import SiteTopologyChangeContainer from '@/components/site-administration/site-topology-change-container'
import SiteTopologyChangeConfirmation from '@/components/site-administration/site-topology-change-confirmation'

export default {
  components: {
    SiteTopologyChangeConfirmation,
    SiteTopologyChangeContainer,
    NoSiteAdministrable,
    SelectSite,
    SiteInstantChargeConfirmation,
    SiteInstantChargeContainer
  },
  name: 'SiteAdministration',
  data: () => ({
    confirmation: false,
    warning: false,
    selectedTopology: null
  }),
  computed: {
    ...mapGetters('site', ['getSites', 'getSite']),
    canInstantCharge () {
      return this.getSite?.canInstantCharge
    },
    canChangeTopology () {
      return this.getSite?.canChangeTopology
    }
  },
  methods: {
    ...mapActions('site', ['loadSites', 'loadSite', 'activateInstantCharge', 'deactivateInstantCharge', 'enableTopology']),
    loadTheSite () {
      if (this.$route.name === 'Generic Site Administration') {
        this.loadFirstSite()
      } else {
        this.loadPathSite()
      }
    },
    loadFirstSite () {
      const firstSiteId = this.getSites[0].id
      this.loadSite(firstSiteId)
      this.$router.replace({
        name: 'Site Administration',
        params: {
          siteId: firstSiteId
        }
      })
    },
    loadPathSite () {
      const siteId = this.$route.params.siteId
      this.loadSite(siteId)
    },
    activateInstantChargeAndHideConfirmation () {
      this.activateInstantCharge()
      this.confirmation = false
    },
    showConfirmation () {
      this.confirmation = true
    },
    hideConfirmation () {
      this.confirmation = false
    },
    changeTopology () {
      this.enableTopology(this.selectedTopology)
        .then(() => {
          const deliveryPoint = this.getSite.deliveryPoints.find(it => it.topologies.find(topology => topology.id === this.selectedTopology))
          localStorage.setItem(`${deliveryPoint.id}-TOPOLOGY-LAST-CHANGED`, moment())
          this.hideWarning()
        })
    },
    hideWarning () {
      this.warning = false
      this.selectedTopology = null
    },
    updateTopology (topologyId) {
      this.selectedTopology = topologyId
      this.warning = true
    }
  },
  mounted () {
    this.loadSites(this.loadTheSite)
  },
  beforeRouteUpdate (to, from, next) {
    const siteId = to.params.siteId
    this.loadSite(siteId)
    next()
  }
}
</script>

<style scoped>
#site-administration {
  margin-left: 98px;
  margin-right: 98px;
}
</style>
